module.exports = __webpack_public_path__ + "static/desktop-silver-stepper-icon-ja-03c7d580176dc2e21d1e02e40d678baf.svg";